import { render } from "./TopStatistics.vue?vue&type=template&id=ff54d816"
import script from "./TopStatistics.vue?vue&type=script&lang=js"
export * from "./TopStatistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__